import { render, staticRenderFns } from "./IconWithTick.vue?vue&type=template&id=351d5909&"
import script from "./IconWithTick.vue?vue&type=script&lang=js&"
export * from "./IconWithTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports